(ns app.bulk.register
  "UI register entries for the bulk scheduling slice."
  (:require [app.bulk.actions :as actions]
            [app.bulk.gallery-modal :as gallery-modal]
            [app.bulk.page :as page]
            [app.bulk.preview-modal :as preview-modal]
            [app.bulk.unsaved-confirm-modal :as unsaved-confirm-modal]))

(def register
  (concat
    [page/page
     gallery-modal/modal
     preview-modal/modal
     unsaved-confirm-modal/modal]
    actions/register))
